import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppContext } from '../../utils/content.util';

export default function AuthenticatedRoute({ children }: any) {
  const { pathname, search } = useLocation();
  const { isAuthenticated } = useAppContext();

  if (!isAuthenticated) {
    return <Navigate to={`/login?redirect=${pathname}${search}`} />;
  }

  return <div className="admin-section">{children}</div>;
}
